// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"e5","speechCardBox":"e5","speech-img-box":"e6","speechImgBox":"e6","card-content":"e7","cardContent":"e7","card-src":"e8","cardSrc":"e8"};